import "./lead.css";
import { useHomeContent } from "../../hooks/useHomeContent";
import { FeedbackForm } from "../../../../components/landing/forms/FeedbackForm/FeedbackForm";

export const Lead = () => {
  const data = useHomeContent();
  if (!data?.lead) return null;

  const c = data.lead;
  const submitLabel =
    c.submitLabel ?? data?.feedbackModal?.submitLabel ?? data?.common?.send ?? "Send";

  return (
    <section
      className="oc-lead oc-section"
      style={{ backgroundImage: `url(${c.bg})` }}
    >
      <div className="oc-lead__overlay" />

      <div className="oc-container oc-lead__inner">
        <div
          className="oc-lead__left"
          dangerouslySetInnerHTML={{ __html: c.textHtml }}
        />

        <div className="oc-lead__right">
          <div className="oc-lead__card">
            <FeedbackForm
              thanksText={c.thanksText}
              submitLabel={submitLabel}
              showTender
              copy={data.feedbackForm}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
